import React, { useEffect, useState } from 'react';
import Toast from '../../helpers/Toast';
import { KpiService } from '../../services/KpiService';
import AssistanceDashboardUtilities from './AssistanceDashboardUtilities';
import RegisteredTimeDashboardUtilities from './RegisteredTimesDashboardUtilities';
import AssistanceWithOpenExecutionsDashboardUtilities from './AssistanceWithOpenExecutionsDashboardUtilities';
import { Col, Row } from 'reactstrap';

interface KpiDashboardContainerProps {
    technicianFilter?: string | null;
}

const KpiDashboardContainer: React.FC<KpiDashboardContainerProps> = ({ ...props }) => {
    const [kpiData, setKpiData] = useState<any | null>(null);
    const kpiService = new KpiService();

    const fetchKpiDashboardMetrics = async () => {
        const response = await kpiService.GetKpiDashboardMetrics(props?.technicianFilter ?? '');

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        setKpiData(response.obj);
    };

    useEffect(() => {
        fetchKpiDashboardMetrics();
    }, []);

    return (
        <div>
            <Row>
                <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                    <AssistanceDashboardUtilities kpiData={kpiData} />
                </Col>
                <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                    <RegisteredTimeDashboardUtilities kpiData={kpiData} />
                </Col>
                <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                    <AssistanceWithOpenExecutionsDashboardUtilities kpiData={kpiData} />
                </Col>
            </Row>
        </div>
    );
};

export default KpiDashboardContainer;